/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Compliance_Pattern_ExpressionsInputs */



/**
* | output |
* | --- |
* | "{count} expressions" |
*
* @param {Compliance_Pattern_ExpressionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_pattern_expressions = /** @type {((inputs: Compliance_Pattern_ExpressionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Pattern_ExpressionsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Ausdrücke`)
	return /** @type {LocalizedString} */ (`${i?.count} expressions`)
});